import { useAuth } from 'app/provider/auth'
import { WriteForUsScreen } from './write-for-us-screen'

export const WriteForUsScreenContainer = () => {
  const { user } = useAuth()

  return <WriteForUsScreen user={user} />
}
